<div id="accordion-header-contents">
  {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OPPORTUNITY_CREATE' | translate }}
  <mat-icon id="close-nav" (click)="closeSideNav()">close</mat-icon>
</div>
<mat-vertical-stepper class="stepper" [linear]="true" #stepper *ngIf="partnerMarketConfig$ | async as pmConfig">
  <mat-step [stepControl]="accountForm" *ngIf="(skipAccountSelection$ | async) === false">
    <ng-template matStepLabel>
      {{ 'FRONTEND.SALES_UI.FORMS.CHOOSE_ACCOUNT' | translate }}
    </ng-template>
    <form class="step-body" [formGroup]="accountForm">
      <sales-ui-account-selector [allowNoneOption]="false" [parentFormCtrl]="accountCtrl"></sales-ui-account-selector>
      <div class="step-actions first-step">
        <button data-action="create-opportunity:selected-account" mat-stroked-button matStepperNext>
          {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>
      {{ 'FRONTEND.SALES_UI.FORMS.CHOOSE_LINE_ITEMS' | translate }}
    </ng-template>
    <form class="step-body">
      <sales-ui-sales-order-confirmation
        #salesOrderConfirmation
        [title]="'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OPPORTUNITY_CONTENTS' | translate"
        [lineItems]="[]"
        [partnerId]="pmConfig.partnerId"
        [marketId]="pmConfig.marketId"
        [businessId]="accountForm.controls.firstStepCtrl.value.accountGroupId"
        [editable]="true"
        [startEditing]="true"
        [allowNegativeValues]="true"
        [defaultDisplayCurrency]="pmConfig.currency"
        [bypassQuantityRestrictions]="pmConfig.bypassQuantityLimit"
        [enableEditBillingSchedule]="true"
        [allowDuplicateItems]="true"
        [contractStartDate]="expectedClosedDate$ | async"
      ></sales-ui-sales-order-confirmation>
      <div class="step-actions">
        <button mat-stroked-button matStepperPrevious>
          {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.BACK' | translate }}
        </button>
        <button data-action="create-opportunity:added-items" mat-stroked-button (click)="secondStepNext()">
          {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>
      {{ 'FRONTEND.SALES_UI.FORMS.ADDITIONAL_INFO' | translate }}
    </ng-template>
    <form class="step-body" [formGroup]="additionalInfoForm" autocomplete="off" novalidate>
      <sales-ui-opportunity-pipeline-selector
        (pipelineValues)="setPipelineValues($event)"
      ></sales-ui-opportunity-pipeline-selector>
      <glxy-form-field class="full-width">
        <glxy-label>
          {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.EXPECTED_CLOSE_PLACEHOLDER' | translate }}
        </glxy-label>
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <input
          [readonly]="true"
          matInput
          [matDatepicker]="datePicker"
          name="date"
          [min]="today"
          formControlName="expectedClosedDate"
          [required]="true"
        />
        <mat-datepicker #datePicker></mat-datepicker>
      </glxy-form-field>
      <sales-ui-type-selector
        [defaultType]="defaultOpportunityType"
        (typeChanged)="handleTypeChanged($event)"
      ></sales-ui-type-selector>
      <mat-divider></mat-divider>

      <sales-ui-contract-duration-selector [parentForm]="additionalInfoForm"></sales-ui-contract-duration-selector>

      <mat-divider class="last-divider"></mat-divider>

      <mat-accordion [multi]="true">
        <mat-expansion-panel *ngIf="sortedSalespeople$ | async as salespeople">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.DETAILS' | translate }}
            </mat-panel-title>
            <mat-panel-description>
              <span
                class="detail-salesperson-text"
                *ngIf="additionalInfoForm.controls.selectedSalesperson.value?.fullName as spFullName; else loading"
              >
                {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ASSIGNED_TO' | translate: { person: spFullName } }}
              </span>
              <ng-template #loading>
                <span>{{ 'FRONTEND.SALES_UI.COMMON.LOADING' | translate }}</span>
              </ng-template>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="section-columns">
            <div class="section-column">
              <glxy-form-field class="full-width">
                <glxy-label>
                  {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OPPORTUNITY_NAME' | translate }}
                </glxy-label>
                <input matInput formControlName="opportunityName" />
              </glxy-form-field>
            </div>
            <div class="section-column">
              <glxy-form-field class="full-width">
                <glxy-label>
                  {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ASSIGN_TO' | translate }}
                </glxy-label>
                <mat-select formControlName="selectedSalesperson" [compareWith]="compareSalespeople">
                  <mat-option *ngFor="let sp of salespeople" [value]="sp">
                    {{ sp.fullName }}
                  </mat-option>
                </mat-select>
              </glxy-form-field>
            </div>
          </div>
          <div>
            <glxy-form-field class="full-width">
              <glxy-label>
                {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ADD_SUBSCRIBER_PLACEHOLDER' | translate }}
              </glxy-label>
              <forms-input-tags
                [formControl]="additionalInfoForm.controls.selectedSubscribers"
                [options]="subscribers$ | async"
                [allowCustomTags]="false"
                [allowDuplicates]="false"
                [required]="false"
              ></forms-input-tags>
            </glxy-form-field>
          </div>
          <div>
            <glxy-form-field class="full-width">
              <glxy-label>
                {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OVERVIEW' | translate }}
              </glxy-label>
              <textarea matInput matTextareaAutosize formControlName="overviewNotes"></textarea>
            </glxy-form-field>
          </div>
          <div>
            <glxy-form-field class="full-width">
              <glxy-label>
                {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ADD_TAG_PLACEHOLDER' | translate }}
              </glxy-label>
              <forms-input-tags
                [options]="(tags$ | async) || []"
                [formControl]="additionalInfoForm.controls.tags"
                [allowCustomTags]="true"
                [allowDuplicates]="false"
                [required]="false"
              ></forms-input-tags>
            </glxy-form-field>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="step-actions">
        <button mat-stroked-button matStepperPrevious>
          {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.BACK' | translate }}
        </button>
        <div class="cancel-create-container">
          <button data-action="create-opportunity:cancelled" mat-stroked-button (click)="closeSideNav()">
            {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
          </button>
          <button
            data-action="create-opportunity:created"
            #createButton
            mat-flat-button
            color="primary"
            (click)="saveHandler(pmConfig)"
            [disabled]="saving$ | async"
          >
            <mat-spinner *ngIf="saving$ | async; else submitButtonText" [diameter]="20"></mat-spinner>
            <ng-template #submitButtonText>
              {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CREATE' | translate }}
            </ng-template>
          </button>
        </div>
      </div>
    </form>
  </mat-step>
</mat-vertical-stepper>
